import React from 'react'

import { OverlayTrigger, Tooltip, Container, Row, Col } from 'react-bootstrap'
// import { v4 as uuidv4 } from 'uuid'

// import powerData from '../../data/powerData.json'

const PowerScan = ({ title, data }) => {
  const renderTooltip = (props) => (
    <Tooltip id="button-tooltip" className="text-start" {...props}>
      依據您目前社群經營的成效，提供給您一些指標群，用來衡量您的社群內容是否達到了預期的目標。
    </Tooltip>
  )

  // let scanData = powerData.slice(15, 21)
  const scanData = [
    {
      title: 'AI導師評鑑',
      toolTip:
        'AI導師評鑑是依據社群經營狀況給予的的分級制度。以下是四個不同階段的定義：\n1. 初出茅廬：表示您才剛開始邁入社群經營的階段，正在從一步步地實踐中掌握基本概念和技能。\n2. 精進學習：表示您已經對基礎概念和技能有了一定的了解，開始投入更多時間和精力進行學習，並不斷改進自己的學習方法。\n3. 突破瓶頸：表示您已經掌握了大部分的概念和技能，但還需要克服一些困難和挑戰，才能夠達到更高水平的學習成就。\n4. 完美成長：表示您已經達到了一定的學習成就，能夠獨立思考和解決問題，並能夠將所學應用於實際場景中，不斷追求自我超越和成長。',
      count: data.ai_teacher_comment,
      other: '',
    },
    {
      title: '影響擴散力',
      toolTip:
        '分析過去三天以來，您在社群專頁創作內容的擴散效果，分數越高代表社群推廣的能力越高。',
      count: data.sumfoc_val,
      other: '分',
    },
    {
      title: '話題創造力',
      toolTip:
        '分析過去三天以來，您在社群上的創作內容獲得粉絲熱烈討論的程度，分數經演算法標準化後介於1~10分，分數越高代表您所引領的話題創造力越高。',
      count: data.avefoc_val,
      other: '分',
    },
    {
      title: '好感渲染力',
      toolTip:
        '分析過去三天以來，粉絲對於您在社群上的創作內容所投射的情緒反應，分數越高表示粉絲給您的口碑評價越正面。',
      count: data.emofoc_val,
      other: '分',
    },
    {
      title: '新粉吸引力',
      toolTip: '分析過去三天以來，您的社群吸引新粉加入的績效表現。',
      count: data.newatt_val,
      other: '%',
    },
    {
      title: '社群觸及力',
      toolTip: '統計觸及到您粉絲專頁任何相關內容的用戶人數。',
      count: data.fanres_val,
      other: '人',
    },
  ]

  return (
    <>
      <h4 className="fw-bolder p-3">
        {title}
        <OverlayTrigger
          placement="right"
          delay={{ show: 50, hide: 400 }}
          overlay={renderTooltip}
        >
          <div className="fas fa-question-circle p-1 text-decoration-none"></div>
        </OverlayTrigger>
      </h4>
      <Container>
        <Row xs={1} md={2} lg={3} className="d-flex text-center ">
          {scanData.map((v, i) => {
            return (
              <Col key={i} className="scanItem my-2 ">
                <div className="scanCard h-100 d-flex flex-column justify-content-center align-items-center">
                  <div className="h6">{v.title}</div>
                  <div className="d-flex justify-content-center align-items-center">
                    <span className="fw-bold fs-3">{v.count}</span>
                    <span>{v.other}</span>

                    <OverlayTrigger
                      placement="right"
                      overlay={
                        <Tooltip
                          style={{ whiteSpace: 'pre-wrap' }}
                          id={`tooltip-${v.toolTip}`}
                        >
                          {v.toolTip}
                        </Tooltip>
                      }
                    >
                      <div className="fas fa-question-circle p-1 text-decoration-none"></div>
                    </OverlayTrigger>
                  </div>
                </div>
              </Col>
            )
          })}
        </Row>
      </Container>
    </>
  )
}

export default PowerScan
